export const getFullMediaUrlFromPresignedUrl = (presignedUrl = '') => {
  if (!presignedUrl) {
    return null;
  }

  const urlWithoutQueryParams = presignedUrl.split('?')[0];
  return urlWithoutQueryParams;
};



// WEBPACK FOOTER //
// ./src/utils/getFullMediaUrlFromPresignedUrl.js